import axiosClient from "@/libs/axiosClient";

export const getWildcardCSRHost = ({ groupName, sslProvider }) => {
    return axiosClient.get(`/certs/wildcard/get-csr-host/${sslProvider}?groupName=${groupName}`);
};


// WEBPACK FOOTER //
// ./src/api/certs.js